import { routes } from "../../../../router";
import { action, observable } from "mobx";
import ViewModel from "../../../../infrastructure/ViewModel";
import RouteList from "../../../../infrastructure/RouteList";
import ContractsStore from "../../../../store/ContractsStore";
import Utils from "../../../../infrastructure/Utils";
import PageContext from "../../../../infrastructure/PageContext";
import StateLicenseStore from "../../../../store/StateLicenseStore";
import NotificationStore from "../../../../store/NotificationStore";
export class LicenseManagementViewModel implements ViewModel {
  get CanClose(): boolean {
    throw new Error("Method not implemented.");
  }
  get CanRoute(): boolean {
    return true;
  }
  get IsLoaded(): boolean {
    throw new Error("Method not implemented.");
  }
  get IsLoading(): boolean {
    throw new Error("Method not implemented.");
  }
  Close(): void {
    throw new Error("Method not implemented.");
  }

  Route = async (currentRoute: RouteList): Promise<void> => {};

  @observable gridApi: any;
  @observable gridApiData: any;
  @observable pageIndex: number = 0;
  @observable pageSize: number = 100;
  @observable sortColumn: string = "Id";
  @observable sortAscending: boolean = true;
  @observable fullTextFilter: string = "";
  @observable licenseManagementModelList: any;
  @observable gridApiNoRows: string =
    "<span style='padding-top:80px;'>No records available to display</span>";
  @observable searchInputValue: string = "";
  @observable scrollPosition: number = window.scrollY;
  @observable totalRecords: number = 0;
  @observable lastSubmittedDate: string = "10/04/2024 11:30 PM";
  @observable arrayOfAgentID: number[] = [];
  @observable arrayOfStateLicenseId: number[] = [];
  @observable selectionList:any= [];
  @observable isDeleteConfirm: boolean = false;
  @observable selectedPanel: string = "Pending Requests";
  @observable emailSenderConfirm: boolean = false;
  @observable queueConfirm: boolean = false;
  @observable deQueueConfirm: boolean = false;
  @observable filterGridModel: any;
  @observable filterList: any = [];
  @observable isbuSendRemenders: boolean = false; 
  @observable isSendAllReminderClicked: boolean = false;
  @observable refreshVisible: boolean = true;
  @observable selectedKey: string | undefined = "";
  @observable selectedTabIndex?: number = 0; 
  @observable isActivateTemplateModal:boolean = false;
  @observable isActivateBtnClicked:boolean = false;
  @observable oldPageIndex:number=0;
  @observable isbuQueueNiparUpdate:boolean = false;
  @action Load = async () => {
    this.selectedPanel = 'Pending Requests';
    this.selectedTabIndex = 0; 
    this.resetShowMoreProps();
    this.gridApiData = [];
    Utils.listenScrollEvent(PageContext.updateHorizontalScrollBar);
    await this.getData();
  };

  @action getStateFilterLookup = async () => {
    let result = await ContractsStore.appointmentStates();
    return result ? result.map((i) => i.abbreviation) : [];
  };

  @action getStatusFilterLookup = async () => {
    let licenseStatuses = await StateLicenseStore.getAllStateLicenseStatus();
    return licenseStatuses ? licenseStatuses.map((i) => i.text) : [];
  };

  @action getResidencyStatusFilterLookup = async () => {
    let statuses = await ContractsStore.getAllResidencyStatus();
    return statuses ? statuses.map((i) => i.text) : [];
  };

  @action onSearchChange = (e: any) => {
    this.searchInputValue = e.target.value;
    if (this.searchInputValue.length == 0) {
      this.resetShowMoreProps();
    }
    if (this.searchInputValue.length > 2 || this.searchInputValue.length == 0) {
      this.getData();
    }
  };

  @action resetShowMoreProps = () => {
    this.pageIndex = 0;
    this.pageSize = 100;
    this.sortColumn = "id";
    this.sortAscending = true;
    this.searchInputValue = "";
    this.arrayOfAgentID = [];
    this.arrayOfStateLicenseId = [];
    this.filterGridModel = undefined;
  };

  @action filterChange = async () => {
    this.filterList = [];
    if (this.filterGridModel) {
      let keys = Object.keys(this.filterGridModel);
      keys.forEach((key: any) => {
        const values = this.filterGridModel[key].values;
        const filter = this.filterGridModel[key].filter;
        const dateFrom = this.filterGridModel[key].dateFrom;
        const type = this.filterGridModel[key].filterType;
        this.filterList.push({
          key: key,
          set: type == "set" ? values : [],
          text: type == "text" ? filter : type == "date" ? dateFrom : "",
        });
      });
    }
  };
  @action onRowsPerPage = async (value: number) => {
    this.pageSize = value;
    this.getData();
  };
 
  onPaginationChanged = async (params: any = null, pageIndex: number) => {
  
      
    
    this. arrayOfAgentID=[];
    this. arrayOfStateLicenseId=[];
    const selectedData = this.gridApi.getSelectedRows();  
    let agentID = (selectedData || []).map((i: any) => i.agentId);
    let stateLicenseId  = (selectedData || []).map((i: any) => i.id);
 
      let cPageData= this.selectionList.findIndex((p)=>p["page"]===this.pageIndex);
      if(cPageData>=0 )
      { 
        this.selectionList.splice(cPageData,1);
      }
      if(Array.isArray(agentID))
         {
            for(const data of agentID){          
              this. arrayOfAgentID.push(data);         
            }
            for(const data of stateLicenseId){           
              this. arrayOfStateLicenseId.push(data);
            }         
       }
          
            if(this. arrayOfAgentID.length>0){ 
            this.selectionList.push({page: this.oldPageIndex,
            agents:this. arrayOfAgentID,
            licenses: this. arrayOfStateLicenseId
          });
        }
 
        this.pageIndex = pageIndex;
        this.oldPageIndex=pageIndex;
    this.getData();
  };

  @observable templateID:number = 0;
  @observable isActiveTemplate:Boolean = false;
  @action getData = async () => {  
    this.isActiveTemplate = false;
    PageContext.isLoading = true;
    this.filterChange();
    let response = await StateLicenseStore.getAllLicenseManagement(
      this.pageIndex,
      this.pageSize,
      this.sortColumn,
      this.sortAscending,
      this.searchInputValue,
      this.filterList && this.filterList.length > 0
        ? JSON.stringify(this.filterList)
        : "",
        this.selectedPanel == 'Audit History'
    );
    if (response && response.data) {      
      this.gridApiData = response.data;     
      this.totalRecords = response.recordCount || 0;
      this.lastSubmittedDate = "10/04/2024 11:30 PM";  
      PageContext.updateHorizontalScrollBar();
    } else {
      this.gridApiData = [];
      this.totalRecords = 0;
    }
    setTimeout(() => {
      this.gridApi.setGridOption("rowCount", this.totalRecords);
      PageContext.isLoading = false;
           this.setRowsSelected();
    }, 100);    
  };
 setRowsSelected()
  {  
    let cPageData= this.selectionList.findIndex((p)=>p["page"]===this.pageIndex);
    if(cPageData>=0)
    {      
      this.arrayOfAgentID= this.selectionList[cPageData].agents;
      this.arrayOfStateLicenseId= this.selectionList[cPageData].licenses;
    }
    if(this.arrayOfAgentID && this.arrayOfAgentID .length>0)
    { 
      for (let i = 0; i < this.arrayOfAgentID.length; i++) 
        {        
          this.setRowSelected(  this.arrayOfStateLicenseId[i], this.arrayOfAgentID[i]);
        }
    }
    
  }
  setRowSelected (id:number, agentId:number)   {
    
    this.gridApi.forEachNode((rowNode:any) => 
      { 
        if(rowNode.data)
        { 
           if (rowNode.data.id === id && rowNode.data.agentId === agentId) {
            
              rowNode.setSelected(true);
            } 
          
        }
           
    });
  
  }

  resetRowsSelection()
  { 
    this.selectionList=[];
      this.arrayOfAgentID = [];
      this.arrayOfStateLicenseId = [];
      this.gridApi.forEachNode((rowNode:any) => 
      { 
        if(rowNode.data)
        {            
              rowNode.setSelected(false);
        }           
    });
  }
  @action getDataByShowMore = () => {
    this.scrollPosition = window.scrollY;
    PageContext.isLoading = true;
    this.pageIndex += 1;
    this.getData();
  };
 
  @action setGridApi = (api: any) => { 
    this.gridApi = api;  
  };

  @action getGridApi = () => {
     this.setRowsSelected() ;
    return this.gridApi;
  };

  @action setFilterGridModel = async (filterModel: any) => {
    this.filterGridModel = filterModel;
    this.pageIndex = 0;
    this.pageSize = 100;
    this.arrayOfAgentID = [];
    this.arrayOfStateLicenseId = [];
    if (filterModel) {
      await this.getData();
      setTimeout(() => {
        this.gridApi.redrawRows();
      }, 0);
    }
  };

  @action onSelectionChanged = async () => {    
    const selectedData = this.gridApi.getSelectedRows();     
     this.arrayOfAgentID = (selectedData || []).map((i: any) => i.agentId);
     this.arrayOfStateLicenseId = (selectedData || []).map((i: any) => i.id); 
  };

  @action sendRemindersConfirmation = async (value: boolean) => {
    this.emailSenderConfirm = value;
  };

  @action queueConfirmation = async (value: boolean) => {
    this.queueConfirm = value;
  };

  @action deQueueConfirmation = async (value: boolean) => {
    this.deQueueConfirm = value;
  };

  @action sendReminders = async () => {
    let distinctID = [...new Set(this.arrayOfStateLicenseId)];
    let body = {
      stateLicenseIds:
        this.isbuSendRemenders && this.totalRecords > 0
          ? []
          : this.arrayOfStateLicenseId.length > 0 &&
            !this.isbuSendRemenders 
          ? distinctID
          : [],
    };
    let response = await StateLicenseStore.sendReminders(body);
    this.emailSenderConfirm = false;
    if (this.isbuSendRemenders) {
      Utils.showSuccessToaster(
        "License renewal reminders are queued. Agents will receive the email shortly.",
        6000
      );
    } else {
      Utils.showSuccessToaster(
        "License renewal reminders sent" +
          (response > -1 ? " to " + response + " agents." : "."),
        6000
      );
    }
       this. resetRowsSelection(); 
    this.getData();
  };

  @action activateTemplate = async()=>{
    this.isActivateBtnClicked = true;
    
    let reqData = {
      id: this.templateID,
      status: true,
    };
    let res = await NotificationStore.updateNotificationStatus(reqData);     
      Utils.showSuccessToaster(
        "Email template activated. Agents/agencies will receive email reminders.",
        6000
      );
      
      this.isActivateTemplateModal = false;
      this.isActivateBtnClicked = false;
    setTimeout(() => { 
      if(this.isSendAllReminderClicked){
        this.sendRemindersConfirmation(true);
        this.isSendAllReminderClicked = false;
      }else{
        this.sendReminders(); 
      }
    }, 1000);
  }
  @action handleActivateModal =async (value:boolean) =>{
    this.isActivateTemplateModal = value;  
  }

  @action closeActivateTemplate = ()=>{
    this.handleActivateModal(false);
    
    if(this.isSendAllReminderClicked){
      this.isSendAllReminderClicked = false; 
    }  
    Utils.showWarningToaster(
      "The 'State License is Expiring or Expired' email template is inactive. Email reminders will not be sent to agents/agencies.",
      6000
    );
  }

  @action handleActivateTemplateService =async (action:string)=>{
    this.templateID = 0;
    let istemplateActive  = await NotificationStore.getNotificationStatus();
    this.templateID = istemplateActive || 0;
    console.log("LVC flag ", istemplateActive);
    if(istemplateActive > 0){
      this.handleActivateModal(true);
    }else{
      if(action == 'all'){  
        this.sendRemindersConfirmation(true);
      }else if(action =="selection"){
        this.sendReminders(); 
      }
    }
  }

  @action sendQueue = async () => {
    let distinctID = [...new Set(this.arrayOfAgentID)];
    let body = {
      agentIds:
        this.isbuQueueNiparUpdate && this.totalRecords > 0
          ? []
          : this.arrayOfAgentID.length > 0 &&
            !this.isbuQueueNiparUpdate 
          ? distinctID
          : [],
    }; 
    
    let response = await StateLicenseStore.sendQueue(body);
    
    this.queueConfirm = false; 

    if(response === 0 ) {
      Utils.showSuccessToaster(
        "No update available for requested NPN(s).",
        6000
      );
    }else {
      Utils.showSuccessToaster(
        `${response}/${distinctID.length||0} selected NPNs updated`,
        6000
      );
    } 
        this. resetRowsSelection(); 
    this.getData();
  };

  @action sendDeDeueue = async () => {
    let body = {
      agentIds:
        this.arrayOfAgentID.length > 0 &&
        this.arrayOfAgentID.length != this.totalRecords
          ? this.arrayOfAgentID
          : undefined,
    };
    let response = await StateLicenseStore.sendDeQueue(body);
    this.deQueueConfirm = false;
    Utils.showSuccessToaster(
      "Request submitted to NIPR" +
        (response > -1 ? " for " + response + " agents." : ".") +
        " This may take 1-2 days to process.",
      6000
    );
    this.getData();
  };

  @action handleTabClick = (index: number | undefined, key: string): void => {
    this.resetShowMoreProps();
    this.selectedTabIndex = index;
    this.setSelectedPanel(key);
  };

  @action setSelectedPanel = (value: string) => {
    this.selectedPanel = value; 
    if(value =="Audit History"){
      this.sortColumn = 'modifiedDate';
      this.sortAscending = true;
    }
    setTimeout(() => { 
      this.getData(); 
    }, 100);
  };

  @action goToAdmin = () => {
    routes.administration.push();
  };
}
